<template>
  <div id="ylContractDialog">
    <ylContractDialogMobile v-if="isMobileScreen" :info="info" @cancelModal="cancelModal" />
    <ylContractDialogPC v-else :info="info" @cancelModal="cancelModal" />
  </div>
</template>

<script>
export default {
  name: "ylContractDialog",
  components: {
    ylContractDialogMobile: () => import("./components/mobile.vue"),
    ylContractDialogPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      info: '',
      info2: {},
      // isPC: true,
    }
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    // this.riskStatement()
    this.accreditedInvestorCertification()
  },
  mounted() {
    // 禁止背景滚动
    document.body.style.overflow = 'hidden';
    // 禁止移动端触摸滚动
    // document.addEventListener('touchmove', this.preventTouchMove, { passive: false });
  },
  beforeUnmount() {
    // 恢复背景滚动
    document.body.style.overflow = '';
    // 移除触摸滚动限制
    // document.removeEventListener('touchmove', this.preventTouchMove);
  },
  methods: {
    // preventTouchMove(e) {
    //   e.preventDefault();
    // },
    // async riskStatement() {
    //   const res = await this.$api.riskStatement();
    //   this.info = res.find(item => item.id === 8)?.content
    // },
    async accreditedInvestorCertification() {
      const res = await this.$api.accreditedInvestorCertification();
      if (res.id === 12) {
        this.info = res.content
      }
      const res2 = await this.$api.accreditedInvestorCertificationPrompt();
      if (res2.id === 187) {
        this.info2 = res2
      }
    },
    cancelModal() {
      // console.log(`closePage => `)
      // console.log(this.info2)
      this.$alert(this.info2.content, this.info2.title, {
        center: true,
        confirmButtonText: this.$t('confirm'),
        confirmButtonClass: 'confirm-btn',
        dangerouslyUseHTMLString: true,
        customClass: 'contract-alert'
      }).then(() => {
      }).catch(() => {
      })
    }
  },
};
</script>
<style lang="scss">
  .contract-alert { position: fixed !important; top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; z-index: 999999 !important; }
.contract-alert .el-message-box { border: 5px solid #ff0000 !important; background-color: white !important; max-width: 90% !important; padding: 20px !important; box-shadow: 0 2px 12px rgba(0,0,0,0.1) !important; box-sizing: border-box !important; }
  .el-message-box .el-message-box__btns .el-button.confirm-btn {
    height: 45px !important;
    padding: 0 45px !important;
    border: 1px solid transparent !important;
    border-radius: 5px !important;
    cursor: pointer !important;
    font-size: 1em !important;
    font-weight: 500 !important;
    // color: #db1f40 !important;
    // background-color: #917e7e !important;
    color: #db1f40 !important;
    background-color: #eeeef0 !important;
    border-color: #dfdfdf;
    &:hover {
      background-color: rgba(#e8e8f4, 0.9) !important;
      color: rgba(#ec0832, 0.9) !important;
    }
  }
</style>